import React, { useState } from 'react';
import AdminHeader from './AdminHeader';
import AdminSidebar from './AdminSidebar';
import Dashboard from '../../pages/admin/Dashboard';
import Keuangan from '../../pages/admin/Keuangan';
import Produk from '../../pages/admin/Produk';
import Informasi from '../../pages/admin/Informasi';

const AdminLayout = () => {
  const [activePage, setActivePage] = useState('dashboard');

  const renderPage = () => {
    switch (activePage) {
      case 'dashboard':
        return <Dashboard />;
      case 'keuangan':
        return <Keuangan />;
      case 'produk':
        return <Produk />;
      case 'informasi':
        return <Informasi />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      <AdminSidebar 
        activePage={activePage} 
        setActivePage={setActivePage}
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <AdminHeader />
        
        <main className="flex-1 overflow-y-auto p-6">
          {renderPage()}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;